import React from 'react'
import { Router, Route, Redirect, Switch } from 'react-router-dom'
import { AdminLayout } from '../_components/Shared/Layout/AdminLayout'
import { MemberLayout } from '../_components/Shared/Layout/MemberLayout'
import { history } from '../_helpers'
import { connect } from 'react-redux'

// import Home from '../containers/home'

// import { PrivateRoute } from '../_components'
import { LoginPage } from '../LoginPage'
import { MembersLoginPage } from '../LoginPage/MembersLoginPage'
import { HomePage } from '../HomePage'
import Callback from '../Callback/index'
import CallbackFailed from '../CallbackFailed/index'

import ExamCallback from '../ExamCallback/index'
import ExamCallbackFailed from '../ExamCallbackFailed/index'

import { Dashboard } from '../_components/Dashboard/index'


import User from '../_components/User/index';
import NewUser from '../_components/User/New';
import EditUser from '../_components/User/Edit';

import Union from '../_components/Union/index';
import Teacher from '../_components/Teacher/index';
import Lesson from '../_components/Lesson/index';
// import NewUnion from '../_components/Union/new';
// import EditUnion from '../_components/Union/edit';

import Question from '../_components/Question/index';

import Class from '../_components/Class/index';
// import NewClass from '../_components/Class/new';
// import EditClass from '../_components/Class/edit';

import { Member } from '../_components/Member/index';
import NewMember from '../_components/Member/New';
import Attendance from '../_components/Member/Attendance';
// import EditMember from '../_components/Member/edit';

import Message from '../_components/Message/index';
import Payment from '../_components/Payment/index';
// import PaymentResult from '../_components/Payment/PaymentResult'




import { MembersDashboard } from '../_components/MembersDashboard/index'
import { MembersExam } from '../_components/MembersDashboard/Exam'
import { StartExam } from '../_components/MembersDashboard/StartExam'
import { MemberPayments } from '../_components/MembersDashboard/Payments'
import { MemberProfile } from '../_components/MembersDashboard/Profile'



export const PrivateRoute = ({ component: Component, user, ...rest }) => (
  <Route {...rest} render={props => (
    user && user.token
      ? <AdminLayout><Component {...props} /></AdminLayout>
      : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
  )} />
)

export const MembersRoute = ({ component: Component, user, ...rest }) => (
  <Route {...rest} render={props => (
    user && user.token
      ? <MemberLayout><Component {...props} /></MemberLayout>
      : <Redirect to={{ pathname: '/login/members', state: { from: props.location } }} />
  )} />
)

export const AdminRoute = ({ component: Component, user, ...rest }) => (

  <Route {...rest} render={props => (
    user && parseInt(user.role, 0) === 0
      ? <AdminLayout><Component {...props} /></AdminLayout>
      : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
  )} />
)

export const UnionRoute = ({ component: Component, user, ...rest }) => (

  <Route {...rest} render={props => (

    <AdminLayout><Component {...props} /></AdminLayout>

  )} />
)

class App extends React.Component {
  render() {
    const { user } = this.props;
    return (
      <Router history={history}>
        <Switch>

          <Route path="/" exact component={HomePage} />
          <Route path="/Callback/:id" exact component={Callback} />
          <Route path="/CallbackFailed" exact component={CallbackFailed} />

          <Route path="/ExamCallback/:id" exact component={ExamCallback} />
          <Route path="/ExamCallbackFailed" exact component={ExamCallbackFailed} />

          <MembersRoute user={user} exact path='/Member' component={MembersDashboard} />
          <MembersRoute user={user} exact path='/Member/Exam' component={MembersExam} />
          <MembersRoute user={user} exact path='/Member/StartExam/:id' component={StartExam} />
          <MembersRoute user={user} exact path='/Member/Payments' component={MemberPayments} />
          <MembersRoute user={user} exact path='/Member/Profile' component={MemberProfile} />

          <PrivateRoute user={user} exact path='/dashboard' component={Dashboard} />
          <PrivateRoute user={user} exact path='/admin' component={Dashboard} />

          <Route path="/login" component={LoginPage} exact />
          <Route path="/login/members" component={MembersLoginPage} exact />

          <AdminRoute user={user} exact path="/admin/Union" component={Union} />
          <UnionRoute user={user} exact path="/admin/Teacher" component={Teacher} />
          <UnionRoute user={user} exact path="/admin/Lesson" component={Lesson} />
          <AdminRoute user={user} exact path="/admin/Question" component={Question} />
          {/* <AdminRoute user={user} exact path="/admin/Union/new" component={NewUnion} />
          <AdminRoute user={user} exact path="/admin/Union/:id/edit" component={EditUnion} /> */}

          {/* <AdminRoute user={user} exact path="/admin/Class" component={Class} /> */}

          <UnionRoute exact path="/admin/Class" component={Class} />

          {/* <AdminRoute user={user} exact path="/admin/Class/new" component={NewClass} />
          <AdminRoute user={user} exact path="/admin/Class/:id/edit" component={EditClass} /> */}

          {/* <AdminRoute user={user} exact path="/admin/Member" component={Member} /> */}

          <UnionRoute exact path="/admin/Member" component={Member} />

          {/* {user && (parseInt(user.role, 0) === 0 || parseInt(user.role, 0) === 1) ?
            <UnionRoute exact path="/admin/Member/New" component={NewMember} />
            : <Redirect to={{ pathname: '/login' }} />
          } */}

          <UnionRoute exact path="/admin/Member/Attendance" component={Attendance} />

          {/* <AdminRoute user={user} exact path="/admin/Member/:id/edit" component={EditMember} /> */}

          <UnionRoute user={user} exact path="/admin/Member/New" component={NewMember} />

          <AdminRoute user={user} exact path="/admin/Message" component={Message} />
          <UnionRoute user={user} exact path="/admin/Payment" component={Payment} />

          <AdminRoute user={user} exact path="/admin/User" component={User} />
          <AdminRoute user={user} exact path="/admin/User/new" component={NewUser} />
          <AdminRoute user={user} exact path="/admin/User/:id/edit" component={EditUser} />

          {/* <Route exact path="/payment/paymentResult/:memberid/:paymentId/" component={PaymentResult} /> */}

        </Switch>
      </Router>

    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  // console.log(user.role);
  return {
    user
  };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
